import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const names = ['Martín G.', 'Sofía L.', 'Diego A.', 'Valentina R.', 'Federico M.', 'Lucía P.', 'Joaquín S.', 'Camila T.', 'Mateo V.', 'Agustina C.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'San Juan'];
function getRandomItem(arr: string[]) {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomTime() {
  return Math.floor(Math.random() * 59) + 1;
}
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      setPurchaseData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        time: getRandomTime()
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Auto dismiss after 5s
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 3000);
    // Recurring interval (every 12 seconds)
    const interval = setInterval(() => {
      showPopup();
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-4">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex gap-4 items-start" data-id="element-5">
          <div className="bg-[#0a1733] rounded-md p-2 flex-shrink-0" data-id="element-6">
            <img src="https://cdn.magicpatterns.com/uploads/8ZwAo6mkXw2ycicN6MmZXG/ChatGPT_Image_10_jun_2026,_15_57_11_(2).png" alt="MegaPack" className="w-10 h-10 object-cover rounded" data-id="element-7" />
          </div>
          <div className="flex-1" data-id="element-8">
            <div className="flex justify-between items-start" data-id="element-9">
              <p className="text-sm font-semibold text-gray-900 leading-tight" data-id="element-10">
                🔥 {purchaseData.name} de {purchaseData.city}, Argentina acaba
                de comprar el MegaPack
              </p>
              <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 ml-2" data-id="element-11">
                &times;
              </button>
            </div>
            <div className="flex items-center mt-1 gap-2" data-id="element-12">
              <span className="text-xs text-gray-500" data-id="element-13">
                hace {purchaseData.time} minutos
              </span>
              <div className="flex" data-id="element-14">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-[#e0b73c] text-[#e0b73c]" data-id="element-15" />)}
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}